import { IconClock } from '@ds/icons/IconClock'
import { IconPackage } from '@ds/icons/IconPackage'
import { IconWarning } from '@ds/icons/IconWarning'

export const REFURBISHER_ICONS = {
  box: IconPackage,
  warning: IconWarning,
  clock: IconClock,
}
